import {
  FormPageInputItem,
  FormPageInputItemPasswordHash,
  FormPageInputItemPasswordHashText,
  INPUT_ITEM_TYPE,
  PasswordHashProperty,
  PASSWORD_HASH_PROPERTY_INPUT_TYPE,
} from 'shared';

const handleText = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemPasswordHashText => {
  if (formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.passwordHashText) {
    return {
      inputItemType: INPUT_ITEM_TYPE.passwordHashText,
      password: formPageInputItem.password || '',
    };
  }
  return {
    inputItemType: INPUT_ITEM_TYPE.passwordHashText,
    password: '',
  };
};

export const convertPasswordHashInitialValue = (
  property: PasswordHashProperty,
  formPageInputItem?: FormPageInputItem
): FormPageInputItemPasswordHash => {
  switch (property.inputFormat.inputType) {
    case PASSWORD_HASH_PROPERTY_INPUT_TYPE.text:
      return handleText(formPageInputItem);
  }
};
